module.exports = __webpack_public_path__ + "img/iconos4.2d9f3b06.png";